import { randomBytes } from 'crypto';

/**
 * Parse's own objectId alphabet and width, mirrored from `cryptoUtils.randomString`.
 *
 * Matching the server's format matters because these ids are indistinguishable from
 * generated ones once written: anything downstream that validates an id's shape, embeds
 * it in a path, or sizes an index keeps working without knowing who minted it.
 */
const ALPHABET = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
const OBJECT_ID_SIZE = 10;

/**
 * Mints objectIds for objects that are not written yet.
 *
 * The reason this exists at all: Parse resolves no ids between the sub-requests of a
 * batch, so a pointer can only reference an object whose id was already known when the
 * batch was assembled. Assigning ids up front is what lets an object and the rows
 * pointing at it be created in a single transaction.
 *
 * With a 62-character alphabet over 10 positions a collision is remote, and a collision
 * that did occur would violate the primary key and abort the transaction rather than
 * overwrite anything.
 */
export class ParseObjectIdGenerator {
  public generate(): string {
    const bytes = randomBytes(OBJECT_ID_SIZE);

    let objectId = '';
    for (const byte of bytes) objectId += ALPHABET[byte % ALPHABET.length];

    return objectId;
  }
}
